<app-loader></app-loader>
<div class="payment-option">
    <h4>Spot Count Update</h4>
    <div class="custom-close" (click)="close()">
        <img src="../../assets/images/new-close.svg" alt="Close"/>
    </div>
</div>

<div class="booking-summary driver-booking-summer">
    <div class="payment-fullwidth">
        <div class="payment-outer">
            <div class="common-border">
                <div class="perferd-outer">
                    <p class="payment-text">Choose payment option</p>
                    <div class="premed-checkbox" *ngIf="displayedPaymentMethods?.length">
                        <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="isPreferredPaymentSelected"
                            (onChange)="onPreferredCheck(isPreferredPaymentSelected)" />
                        <h5>Preferred Payment Method</h5>
                    </div>
                    <div [class.pay-border]="displayedPaymentMethods?.length" [class.view-scroll]="viewMore">
                        
                        <div *ngFor="let data of displayedPaymentMethods" class="payment-method-box"
                            [class.disabled]="!isPreferredPaymentSelected">

<div *ngIf="data.type === 'card'; else bankDetails">

                                <div class="card-information">
                                    <ul>
                                        <li class="li-first">
                                            <div class="holder-name account-no">
                                                <p-radioButton [class.disabled]="!isPreferredPaymentSelected"
                                                    name="paymentMethod" [(ngModel)]="paymentMethodSelected"
                                                    (click)="onPaymentChange(data)" [value]="data"
                                                    inputId="paymentRadio{{data.last4}}" />
                                                <div class="card-no">
                                                    <h4>Card Number</h4>
                                                    <p>XXXXXXXXXXXX{{data.last4}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="li-second">
                                            <div class="holder-name">
                                                <h4>Expiry Date</h4>
                                                <p>{{data.expMonth}}/{{data.expYear}}</p>
                                            </div>
                                        </li>
                                        <li class="li-third">
                                            <div class="holder-name">
                                                <h4>Card Holder Name</h4>
                                                <p>{{data.cardHolderName}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>

<ng-template #bankDetails>
                                <div class="card-information">
                                    <ul>
                                        <li class="li-first">
                                            <div class="holder-name account-no">
                                                <p-radioButton [class.disabled]="!isPreferredPaymentSelected"
                                                    name="paymentMethod" [(ngModel)]="paymentMethodSelected"
                                                    [value]="data" (click)="onPaymentChange(data)"
                                                    inputId="paymentRadio{{data.last4}}" />
                                                <div class="card-no">
                                                    <h4>Account Number</h4>
                                                    <p>XXXXXXXXXXXX{{data.last4}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="li-second">
                                            <div class="holder-name">
                                                <h4>Bank Name</h4>
                                                <p>{{data.bankName}}</p>
                                            </div>
                                        </li>
                                        <li class="li-third">
                                            <div class="holder-name">
                                                <h4>Account Holder Name</h4>
                                                <p>{{data.accountHolderName}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-template>
                        </div>

                        <div class="view-more" *ngIf="paymentMethodDetails?.length > 2">
                            <p (click)="viewMoreToggal()" *ngIf="!viewMore">View More</p>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isPreferredPaymentSelected" class="method-outer">
                    <h4>Select Payment Method <span class="custom-star">*</span></h4>
                </div>
                <div *ngIf="isPaymentMethodValid" class="pass-err">
                    Payment method is required.
                </div>
                <form *ngIf="!isPreferredPaymentSelected">
                    <div class="payment-main">
                        <div class="Payment-inner">
                            <div class="card-outer" (click)="getSelectedPaymentMethod(1)">
                                <div class="card-inner">
                                    <h4>
                                        <img src="../../../../../assets/images/payment-card.svg" alt="" />
                                        <span>Card</span>
                                    </h4>
                                    <div class="radio-outer">
                                        <p-radioButton class="payment-method" name="paymentMethod" [value]="1"  [(ngModel)]="selectedPaymentMethod"
                                             variant="filled" />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </form>
                <div class="parking-durationbox">
                    <div *ngIf="updatedBookingData?.parkingDuration" class="duration-inner">
                        <h4>Parking Duration</h4>
                        <h4>{{updatedBookingData?.parkingDuration}}</h4>
                    </div>
                        <div *ngIf="updatedBookingData?.increasedSpots > 0" class="duration-inner">
                        <h4>Spot Count</h4>
                        <h4>{{updatedBookingData?.increasedSpots}}</h4>
                    </div>
                    <div *ngIf="updatedBookingData?.amount" class="duration-inner">
                        <h4>Amount</h4>
                        <h4>${{updatedBookingData?.amount}}</h4>
                    </div>
                       <div *ngIf="updatedBookingData?.coupanAmount" class="duration-inner">
                        <h4>Coupon Discount</h4>
                        <h4>${{updatedBookingData?.coupanAmount}}</h4>
                    </div>
                    <div *ngIf="updatedBookingData?.taxAndFees>0" class="duration-inner">
                        <h4 *ngIf="updatedBookingData?.taxAndFees>0">Taxes</h4>
                        <h4 *ngIf="updatedBookingData?.taxAndFees >0"> ${{updatedBookingData?.taxAndFees | digitFormat}}
                        </h4>
                    </div>
                    <div *ngIf="updatedBookingData?.transactionFees>0" class="duration-inner">
                        <h4>Fee</h4>
                        <h4 *ngIf="updatedBookingData?.transactionFees >0"> ${{updatedBookingData?.transactionFees |
                            digitFormat}}
                        </h4>
                    </div>
                    <div *ngIf="updatedBookingData?.usedCredit > '0'" class="duration-inner">
                        <h4 *ngIf="updatedBookingData?.usedCredit > '0'">Credit</h4>
                        <h4 *ngIf="updatedBookingData?.usedCredit > '0'">- ${{updatedBookingData?.usedCredit.toFixed(2) |
                            removeDecimal}}</h4>
                    </div>
                </div>
                <div class="pay-new custom-paynew">
                    <div class="updated-outerbox">
                        <div class="inner-box">
                            <div class="pay-now">
                                <p-button [label]="'Pay Now'" (onClick)="payNowButton()">
                                </p-button>

                            </div>
                        </div>

                    </div>
                    <div class="total-outer">
                        <h4>Total: ${{updatedBookingData?.total | removeDecimal}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>